module.exports = __webpack_public_path__ + "media/images/navi__bg-01ca7aef808363e2a7dae420abdc8b00.jpg";